module.exports = __webpack_public_path__ + "img/selected0-min.e4cc546b.png";